<div class="product-dashboard">

  <!-- Stats Section -->
  <div class="stats-section   ">
    <div class="stat-card border">
      <div class="stat-icon">
        <i class="pi pi-link"></i>
      </div>
      <div class="stat-content">
        <h3>{{ stats.totalLinks }}</h3>
        <p>Affiliate Links</p>
      </div>
    </div>

    <div class="stat-card border">
      <div class="stat-icon">
        <i class="pi pi-sync"></i>
      </div>
      <div class="stat-content">
        <h3>{{ stats.totalProducts }}</h3>
        <p>Total Products</p>
      </div>
    </div>

    <div class="stat-card border">
      <div class="stat-icon">
        <i class="pi pi-shopping-cart"></i>
      </div>
      <div class="stat-content">
        <h3>{{ stats.totalConversions }}</h3>
        <p>Conversions</p>
      </div>
    </div>

    <div class="stat-card border">
      <div class="stat-icon">
        <i class="pi pi-indian-rupee"></i>
      </div>
      <div class="stat-content">
        <h3>₹{{ stats.totalEarnings | number:'1.2-2' }}</h3>
        <p>Total Earnings</p>
      </div>
    </div>
  </div>

  <!-- Products Grid -->
  <div class="products-grid ">
    <div *ngFor="let product of affiliateProduct" class="product-card border">
      <div (click)="generateNewLink(product.catalogId)">
        <div class="product-image-container">
          <img [src]="product.imageUrl" alt="{{product.title}}" class="product-image">
        </div>
        <div class="product-header">
          <span class="product-price">₹{{ product.mop | number:'1.2-2' }}</span>
        </div>

        <p class="product-description">{{ product.title }}</p>
      </div>
    </div>
  </div>

  <div class="empty-state" *ngIf="affiliateProduct.length==0">
    <div class="empty-icon">
      <i class="fas fa-link-slash"></i>
    </div>
    <div class="empty-title">No Affiliate Product Found</div>
  </div>
</div>
<!-- Confirmation Modal -->
<div class="modal fade" id="confirmModal" tabindex="-1" (hidden.bs.modal)="onModalClose()">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title  ">
          <span *ngIf="!isLinkGenerated && !isGenerating">Generate Affiliate Link</span>
          <span *ngIf="isGenerating">Generating Link...</span>
          <span *ngIf="isLinkGenerated">Affiliate Link Generated</span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <!-- Before generation -->
        <div *ngIf="!isLinkGenerated && !isGenerating">
          <p>Are you sure you want to generate a new affiliate link for this product?</p>
        </div>

        <!-- During generation -->
        <div *ngIf="isGenerating" class="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-2">Generating your affiliate link...</p>
        </div>

        <!-- After generation -->
        <div *ngIf="isLinkGenerated">
          <p class="mb-3">Your affiliate link has been generated successfully!</p>

          <div class="input-group">
            <input
              type="text"
              class="form-control"
              [value]="generatedLink"
              readonly
              #linkInput>
            <button
              class="btn btn-outline-secondary"
              type="button"
              (click)="copyToClipboard(generatedLink)"
              [disabled]="copySuccess">
              <i class="bi bi-clipboard" *ngIf="!copySuccess"></i>
              <i class="bi bi-check-circle text-success" *ngIf="copySuccess"></i>
              {{ copySuccess ? 'Copied!' : 'Copy' }}
            </button>
          </div>

          <!-- Success message -->
          <div class="alert alert-success mt-2" *ngIf="copySuccess">
            <i class="bi bi-check-circle"></i> Link copied to clipboard!
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <!-- Before generation buttons -->
        <ng-container *ngIf="!isLinkGenerated && !isGenerating">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-danger" (click)="confirmGeneration()">
            Generate Link
          </button>
        </ng-container>

        <!-- During generation -->
        <ng-container *ngIf="isGenerating">
          <button type="button" class="btn btn-secondary" disabled>Cancel</button>
          <button type="button" class="btn btn-danger " disabled>
            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
            Generating...
          </button>
        </ng-container>

        <!-- After generation buttons -->
        <ng-container *ngIf="isLinkGenerated">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button
            type="button"
            class="btn btn-danger"
            (click)="copyToClipboard(generatedLink)">
            <i class="bi bi-clipboard me-1"></i>
            Copy Link
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
